import { render, staticRenderFns } from "./LabelsRegenerateCache.vue?vue&type=template&id=99a5dd8c&"
import script from "./LabelsRegenerateCache.vue?vue&type=script&lang=js&"
export * from "./LabelsRegenerateCache.vue?vue&type=script&lang=js&"
import style0 from "./LabelsRegenerateCache.vue?vue&type=style&index=0&id=99a5dd8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports